/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import {
	HcpSummaryFragmentDoc,
	HcpAffiliationLinkFragmentDoc
} from '../../../../core/fragments/Hcp/HCP.hook';
import { HcoSummaryFragmentDoc } from '../../../../core/fragments/Hco/HCOSummary.hook';
import { BadRequestFragmentDoc } from '../../../../core/fragments/core.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetQuickSearchResultsQueryVariables = Types.Exact<{
	searchPayload: Types.SearchAsYouTypeInput;
}>;

export type GetQuickSearchResultsQuery = {
	__typename?: 'Query';
	searchAsYouType:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| {
				__typename?: 'SearchAsYouTypeResults';
				results: Array<{
					__typename?: 'SearchAsYouTypeResult';
					entity:
						| {
								__typename?: 'HCO';
								vid_V: string;
								veevaid_V: string;
								statusCda_V?: string | null;
								statusCda_VId?: string | null;
								hcoNameCda_V?: string | null;
								displayName_V?: string | null;
								hcoNameShort_V?: string | null;
								hcoNameEnglish_V?: string | null;
								hcoNameIntl_V?: string | null;
								hcoTypeCda_V?: string | null;
								addresses: Array<{
									__typename?: 'Address';
									vid_V: string;
									primaryCda_V?: boolean | null;
									cityCda_V?: string | null;
									cityIntl_V?: string | null;
									stateCda_V?: string | null;
									countryCda_V?: string | null;
									streetAddress1Cda_V?: string | null;
									streetAddress1Intl_V?: string | null;
									postalCodeCda_V?: string | null;
									postalCodeIntl_V?: string | null;
								}>;
								hcoType?: {
									__typename?: 'HCOType';
									id: string;
									name: string;
								} | null;
						  }
						| {
								__typename?: 'HCP';
								vid_V: string;
								veevaid_V: string;
								statusCda_V?: string | null;
								statusCda_VId?: string | null;
								firstNameCda_V?: string | null;
								firstNameIntl_V?: string | null;
								middleNameCda_V?: string | null;
								middleNameIntl_V?: string | null;
								lastNameCda_V?: string | null;
								lastNameIntl_V?: string | null;
								nickname_V?: string | null;
								prefixCda_V?: string | null;
								suffixCda_V?: string | null;
								allDegreeCda_V?: string | null;
								degree1Cda_V?: string | null;
								hcpTypeCda_V?: string | null;
								hcpType?: {
									__typename?: 'HCPType';
									id: string;
									name: string;
									count: number;
								} | null;
								hcpSpecialties: Array<{
									__typename?: 'HCPSpecialty';
									primary: boolean;
									specialty: {
										__typename?: 'Specialty';
										id: string;
										name: string;
										specialtyGroup: {
											__typename?: 'SpecialtyGroup';
											id: string;
											name: string;
										};
									};
								}>;
								addresses: Array<{
									__typename?: 'Address';
									vid_V: string;
									primaryCda_V?: boolean | null;
									cityCda_V?: string | null;
									cityIntl_V?: string | null;
									stateCda_V?: string | null;
									countryCda_V?: string | null;
									streetAddress1Cda_V?: string | null;
									streetAddress1Intl_V?: string | null;
									postalCodeCda_V?: string | null;
									postalCodeIntl_V?: string | null;
								}>;
								affiliationSearch:
									| { __typename?: 'BadRequest' }
									| {
											__typename?: 'HCPAffiliationsResults';
											results: Array<{
												__typename?: 'ParentHCO';
												vid_V: string;
												classOfWork_V?: string | null;
												isPrimaryRelationship_V?: boolean | null;
												parentHcoStatus_VId?: string | null;
												childVeevaid_V?: string | null;
												parentVeevaid_V?: string | null;
												jobTitle_V?: string | null;
												parentHco:
													| {
															__typename?: 'HCO';
															officePhoneCda_V?: string | null;
															vid_V: string;
															veevaid_V: string;
															statusCda_V?: string | null;
															statusCda_VId?: string | null;
															hcoNameCda_V?: string | null;
															displayName_V?: string | null;
															hcoNameShort_V?: string | null;
															hcoNameEnglish_V?: string | null;
															hcoNameIntl_V?: string | null;
															hcoTypeCda_V?: string | null;
															addresses: Array<{
																__typename?: 'Address';
																streetAddress1Cda_V?: string | null;
																streetAddress1Intl_V?: string | null;
																streetAddress2Cda_V?: string | null;
																streetAddress2Intl_V?: string | null;
																postalCodeCda_V?: string | null;
																postalCodeIntl_V?: string | null;
																postalCodeFullUs_V?: string | null;
																cbsa_V?: string | null;
																latitudeCda_V?: number | null;
																longitudeCda_V?: number | null;
																statusCda_V?: string | null;
																statusCda_VId?: string | null;
																subStateAdminUnit_V?: string | null;
																businessCda_V?: boolean | null;
																dpvConfirmedIndicator_V?: string | null;
																buildingIdentifier_V?: string | null;
																phoneCda_V?: string | null;
																faxCda_V?: string | null;
																vid_V: string;
																primaryCda_V?: boolean | null;
																cityCda_V?: string | null;
																cityIntl_V?: string | null;
																stateCda_V?: string | null;
																countryCda_V?: string | null;
																hospitalCampus?:
																	| {
																			__typename?: 'HCO';
																			vid_V: string;
																			veevaid_V: string;
																			statusCda_V?: string | null;
																			statusCda_VId?: string | null;
																			hcoNameCda_V?: string | null;
																			displayName_V?: string | null;
																			hcoNameShort_V?: string | null;
																			hcoNameEnglish_V?: string | null;
																			hcoNameIntl_V?: string | null;
																			hcoTypeCda_V?: string | null;
																			addresses: Array<{
																				__typename?: 'Address';
																				vid_V: string;
																				primaryCda_V?: boolean | null;
																				cityCda_V?: string | null;
																				cityIntl_V?: string | null;
																				stateCda_V?: string | null;
																				countryCda_V?: string | null;
																				streetAddress1Cda_V?: string | null;
																				streetAddress1Intl_V?: string | null;
																				postalCodeCda_V?: string | null;
																				postalCodeIntl_V?: string | null;
																			}>;
																			hcoType?: {
																				__typename?: 'HCOType';
																				id: string;
																				name: string;
																			} | null;
																	  }
																	| {
																			__typename?: 'ResourceNotFound';
																			message: string;
																	  }
																	| null;
															}>;
															hcoType?: {
																__typename?: 'HCOType';
																id: string;
																name: string;
															} | null;
													  }
													| {
															__typename?: 'ResourceNotFound';
															message: string;
													  };
												relationshipType?: {
													__typename?: 'RelationshipType';
													code: string;
													name: string;
												} | null;
											}>;
									  };
						  };
				}>;
		  };
};

export const GetQuickSearchResultsDocument = gql`
	query GetQuickSearchResults($searchPayload: SearchAsYouTypeInput!) {
		searchAsYouType(searchPayload: $searchPayload) {
			... on SearchAsYouTypeResults {
				results {
					entity {
						...HCPSummary
						...HCPAffiliationLink
						...HCOSummary
					}
				}
			}
			...BadRequest
		}
	}
	${HcpSummaryFragmentDoc}
	${HcpAffiliationLinkFragmentDoc}
	${HcoSummaryFragmentDoc}
	${BadRequestFragmentDoc}
`;

/**
 * __useGetQuickSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetQuickSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickSearchResultsQuery({
 *   variables: {
 *      searchPayload: // value for 'searchPayload'
 *   },
 * });
 */
export function useGetQuickSearchResultsQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetQuickSearchResultsQuery,
		GetQuickSearchResultsQueryVariables
	> &
		(
			| { variables: GetQuickSearchResultsQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetQuickSearchResultsQuery,
		GetQuickSearchResultsQueryVariables
	>(GetQuickSearchResultsDocument, options);
}
export function useGetQuickSearchResultsLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetQuickSearchResultsQuery,
		GetQuickSearchResultsQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetQuickSearchResultsQuery,
		GetQuickSearchResultsQueryVariables
	>(GetQuickSearchResultsDocument, options);
}
export function useGetQuickSearchResultsSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetQuickSearchResultsQuery,
				GetQuickSearchResultsQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetQuickSearchResultsQuery,
		GetQuickSearchResultsQueryVariables
	>(GetQuickSearchResultsDocument, options);
}
export type GetQuickSearchResultsQueryHookResult = ReturnType<
	typeof useGetQuickSearchResultsQuery
>;
export type GetQuickSearchResultsLazyQueryHookResult = ReturnType<
	typeof useGetQuickSearchResultsLazyQuery
>;
export type GetQuickSearchResultsSuspenseQueryHookResult = ReturnType<
	typeof useGetQuickSearchResultsSuspenseQuery
>;
export type GetQuickSearchResultsQueryResult = Apollo.QueryResult<
	GetQuickSearchResultsQuery,
	GetQuickSearchResultsQueryVariables
>;
